var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    stroke: "#545454",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#65i1z4u91a)",
    stroke: "{stroke}",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.933 10a1.1 1.1 0 0 0 .22 1.214l.04.04a1.332 1.332 0 0 1-.432 2.176 1.334 1.334 0 0 1-1.454-.29l-.04-.04a1.1 1.1 0 0 0-1.214-.22 1.1 1.1 0 0 0-.666 1.007V14a1.333 1.333 0 1 1-2.667 0v-.06A1.1 1.1 0 0 0 6 12.934a1.099 1.099 0 0 0-1.213.22l-.04.04a1.334 1.334 0 1 1-1.887-1.887l.04-.04a1.1 1.1 0 0 0 .22-1.213 1.1 1.1 0 0 0-1.007-.667H2A1.333 1.333 0 1 1 2 6.72h.06A1.1 1.1 0 0 0 3.067 6a1.1 1.1 0 0 0-.22-1.213l-.04-.04A1.333 1.333 0 1 1 4.693 2.86l.04.04a1.1 1.1 0 0 0 1.214.22H6a1.1 1.1 0 0 0 .667-1.006V2a1.333 1.333 0 1 1 2.666 0v.06A1.1 1.1 0 0 0 10 3.067a1.1 1.1 0 0 0 1.213-.22l.04-.04a1.333 1.333 0 0 1 2.177 1.454 1.334 1.334 0 0 1-.29.433l-.04.04a1.1 1.1 0 0 0-.22 1.213V6a1.1 1.1 0 0 0 1.007.667H14a1.333 1.333 0 0 1 0 2.667h-.06a1.1 1.1 0 0 0-1.007.666z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "65i1z4u91a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsSmall);
export default __webpack_public_path__ + "static/media/settingsSmall.6c5de3c3b5f6b3e0e17bb6f0adb96cc6.svg";
export { ForwardRef as ReactComponent };